var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_289_378)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 35.75C20.07 35.75 15.25 30.93 15.25 25C15.25 19.07 20.07 14.25 26 14.25C31.93 14.25 36.75 19.07 36.75 25C36.75 30.93 31.93 35.75 26 35.75ZM26 15.75C20.9 15.75 16.75 19.9 16.75 25C16.75 30.1 20.9 34.25 26 34.25C31.1 34.25 35.25 30.1 35.25 25C35.25 19.9 31.1 15.75 26 15.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 34.75H22C21.59 34.75 21.25 34.41 21.25 34C21.25 33.59 21.57 33.26 21.98 33.25C20.41 27.89 20.41 22.11 21.98 16.75C21.57 16.74 21.25 16.41 21.25 16C21.25 15.59 21.59 15.25 22 15.25H23C23.24 15.25 23.47 15.37 23.61 15.56C23.75 15.76 23.79 16.01 23.71 16.24C21.83 21.89 21.83 28.11 23.71 33.77C23.79 34 23.75 34.25 23.61 34.45C23.47 34.63 23.24 34.75 23 34.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 34.7499C28.92 34.7499 28.84 34.7399 28.76 34.7099C28.37 34.5799 28.15 34.1499 28.29 33.7599C30.17 28.1099 30.17 21.8899 28.29 16.2299C28.16 15.8399 28.37 15.4099 28.76 15.2799C29.16 15.1499 29.58 15.3599 29.71 15.7499C31.7 21.7099 31.7 28.2699 29.71 34.2199C29.61 34.5499 29.31 34.7499 29 34.7499Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 30.2C23.21 30.2 20.43 29.81 17.75 29.02C17.74 29.42 17.41 29.75 17 29.75C16.59 29.75 16.25 29.41 16.25 29V28C16.25 27.76 16.37 27.53 16.56 27.39C16.76 27.25 17.01 27.21 17.24 27.29C22.89 29.17 29.12 29.17 34.77 27.29C35 27.21 35.25 27.25 35.45 27.39C35.65 27.53 35.76 27.76 35.76 28V29C35.76 29.41 35.42 29.75 35.01 29.75C34.6 29.75 34.27 29.43 34.26 29.02C31.57 29.81 28.79 30.2 26 30.2Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 22.7501C34.92 22.7501 34.84 22.7401 34.76 22.7101C29.11 20.8301 22.88 20.8301 17.23 22.7101C16.83 22.8401 16.41 22.6301 16.28 22.2401C16.16 21.8401 16.37 21.4201 16.76 21.2901C22.72 19.3001 29.28 19.3001 35.23 21.2901C35.62 21.4201 35.84 21.8501 35.7 22.2401C35.61 22.5501 35.31 22.7501 35 22.7501Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_289_378",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_289_378"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_289_378",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/global.bc023712bbca705366e2d7d7c4156364.svg";
export { ForwardRef as ReactComponent };